import { Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { formElementFields } from "./saleAllFields";
import { useSelector } from "react-redux";
import FormField from "../../../../components/common/FormField";
const FirstFormField = ({ formData, setFormData, setIsChanged,onBlurAction,error }: any) => {
  const { userProfile } = useSelector((state: any) => state?.user);

  const [isProfessionalSection, setIsProfessionalSection] = useState(
    userProfile?.features?.includes("Professional Financial") || false // Safe fallback
  );

  useEffect(() => {
    setIsProfessionalSection(
      userProfile?.features?.includes("Professional Financial") || false
    ); // Sync profile changes
  }, [userProfile]);

  const onChangeAction = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { id, value } = event.target;
    setFormData((prevState: any) => ({
      ...prevState,
      [id]: value,
    }));
    setIsChanged(true);
  };

  return (
    <>
      <Grid
        item
        md={12}
        xs={12}
        sx={{ paddingLeft: "0px !important", paddingRight: "16px" }}
      >
        <Grid container spacing={2}>
          {formElementFields.map((field) => (
              <FormField
                key={field.id}
                // onPaste={(e) => e.preventDefault()}
                onKeyDown={(event: any) => {
                  if (
                    event.keyCode === 8 ||
                    event.keyCode === 9 ||
                    event.keyCode === 37 ||
                    event.keyCode === 38 ||
                    event.keyCode === 39 ||
                    event.keyCode === 40 ||
                    event.keyCode === 18 ||
                    event.keyCode === 17 ||
                    event.ctrlKey
                  )
                    return event;
                  if (
                    field?.patternAllowed &&
                    !field?.patternAllowed.test(event.key)
                  ) {
                    event.preventDefault();
                  } else if (
                    field?.patternAllowed &&
                    !field?.patternAllowed.test(event.target.value + event.key)
                  ) {
                    event.preventDefault();
                  }
                }}
                {...{
                  ...field,
                  value: formData[field.id] ?? "",
                  // value: formData[field.id] || "",
                  variant: "outlined",
                  checked:
                    field?.type === "checkbox"
                      ? Boolean(formData[field.id])
                      : undefined,
                  minRows: 2,
                  isNonMarginTop: true,
                  inSingleGridForm: true,
                  onChange: onChangeAction,
                  onBlur: onBlurAction,
                  maxLength: 250,
                  InputProps: {
                    ...(field?.inputProps && field?.inputProps),
                    sx:
                      field?.type === "text" || field?.type === "password"
                        ? { height: "36px" }
                        : {
                            padding: "10px 4px",
                            height: "36px",
                          },
                  },
                  error: error &&error[field.id],
                }}
              />
            ))}
        </Grid>
      </Grid>
    </>
  );
};

export default FirstFormField;
